import { getXmlLine } from 'src/app/utils/soap.utils';
import {
    EditerLigneCommandeChangementStatutBilletterieRetourPopupInput,
    EditerLigneCommandeChangementStatutLocationGestionRetourPopupInput
} from 'src/graphql/generated-types';
import { arrayEmpty, arrayNotEmpty } from 'src/app/utils/array.utils';
import { getFormsList } from 'src/app/board/activity/activity-shared/components/activity-form-response/activity-form-responses.xml';
import { ActivityNewSaleOrderLineStatus } from 'src/app/board/activity/stores/activity-sales/activity-sales.action';
import { SelectedSubventionOrderLine } from 'src/app/board/activity/activity-shared/dialogs/engine-feedback-dialog/engine-feedback-dialog.component';

export const EditerLigneCommandeBilletterieGestionModelXml = (line: SelectedSubventionOrderLine) => {
    const type = isGeneric(line) ? 'EditerLigneCommandeBilletterieArticleGeneriqueGestionModel' : 'EditerLigneCommandeBilletterieGestionModel';
    return `<ligneCommande i:type="d4p1:${type}"
                xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                ${GetEditerLigneXml(line)}
                ${getXmlLine(line, 'LibelleArticle')}
                ${getXmlLine(line, 'PrixVente', {defaultValue: line.PrixDeVente})}
                ${getXmlLine(line, 'ReferenceArticle')}
            </ligneCommande>
            <formulaire xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                        xmlns:i="http://www.w3.org/2001/XMLSchema-instance"
                        xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
                ${!!line.Formulaire ? getFormsList(line.Formulaire, {namespace: 'd4p1'}) : ''}
            </formulaire>
            <isDepassementStockValideByUser>false</isDepassementStockValideByUser>`;
};

export const EditerLigneCommandeRetourPopupGestionModelXml = (line: SelectedSubventionOrderLine) => {
    const type = isGeneric(line) ? 'EditerLigneCommandeRetourPopupGestionArticleGeneriqueModel' : 'EditerLigneCommandeRetourPopupGestionModel';

    return `<ligneCommande i:type="d4p1:${type}"
                xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                ${GetEditerLigneXml(line)}
                <d4p1:ListeSubventionsAccordeesObs>
                ` + line.ListeSubComplementaire.map(l => `
                    <d4p1:SubventionAccordeeModelDTO>
                        ${getXmlLine(l, 'IdEnveloppeSpecifique')}
                        ${getXmlLine(l, 'IsSubventionChoisie', {defaultValue: false})}
                        ${getXmlLine(l, 'MontantAccepte')}
                    </d4p1:SubventionAccordeeModelDTO>
                 `).join('') + `
                </d4p1:ListeSubventionsAccordeesObs>
                ${getXmlLine(line, 'LibelleArticle')}
                ${getXmlLine(line, 'PrixDeVente')}
                ${getXmlLine(line, 'ReferenceArticle')}
        </ligneCommande>
        <formulaire xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                    xmlns:i="http://www.w3.org/2001/XMLSchema-instance"
                    xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
            ${!!line.Formulaire ? getFormsList(line.Formulaire, {namespace: 'd4p1'}) : ''}
        </formulaire>
        <isDepassementStockValideByUser>false</isDepassementStockValideByUser>`;
};

export const EditerLigneCommandeLocationGestionModelXml = (line: SelectedSubventionOrderLine) => {
    const xml = `
            <ligneCommande i:type="dto:EditerLigneCommandeLocationGestionModel"
                xmlns:dto="http://schemas.datacontract.org/2004/07/V2DTO"
                xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                ${getXmlLine(line, 'IdArticle', {namespace: 'dto'})}
                ${getXmlLine(line, 'IdBenef', {namespace: 'dto'})}
                ${getXmlLine(line, 'IdCommande', {namespace: 'dto'})}
                ${getXmlLine(line, 'IdLigneCommande', {namespace: 'dto'})}
                ${getXmlLine(line, 'Quantite', {namespace: 'dto'})}
                ${getXmlLine(line, 'RemarquePrivee', {namespace: 'dto'})}
                ${getXmlLine(line, 'RemarquePublique', {namespace: 'dto'})}
            </ligneCommande>
            <formulaire xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                        xmlns:i="http://www.w3.org/2001/XMLSchema-instance"
                        xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
                ${!!line.Formulaire ? getFormsList(line.Formulaire, {namespace: 'd4p1'}) : ''}
            </formulaire>
            <isDepassementStockValideByUser>false</isDepassementStockValideByUser>
        `;

    return xml;
};

export const EditerLigneCommandeRetourPopupLocationGestionModel = (line: SelectedSubventionOrderLine) => {
    return `<ligneCommande i:type="d4p1:EditerLigneCommandeRetourPopupLocationGestionModel"
                xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                ${GetEditerLigneXml(line)}
                <d4p1:ListeSubventionsAccordeesObs>
                ` + line.ListeSubComplementaire.map(l => `
                    <d4p1:SubventionAccordeeModelDTO>
                        ${getXmlLine(l, 'IdEnveloppeSpecifique')}
                        ${getXmlLine(l, 'IsSubventionChoisie', {defaultValue: false})}
                        ${getXmlLine(l, 'MontantAccepte')}
                    </d4p1:SubventionAccordeeModelDTO>
                 `).join('') + `
                </d4p1:ListeSubventionsAccordeesObs>
        </ligneCommande>
        <formulaire xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                    xmlns:i="http://www.w3.org/2001/XMLSchema-instance"
                    xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
            ${!!line.Formulaire ? getFormsList(line.Formulaire, {namespace: 'd4p1'}) : ''}
        </formulaire>
        <isDepassementStockValideByUser>false</isDepassementStockValideByUser>`;
};

export const EditerLigneCommandeChangementStatutGestionModelXml =
    ({
         line,
         isEngineFeedback,
     }: { line: ActivityNewSaleOrderLineStatus, isEngineFeedback: boolean }) => {
        const type = isEngineFeedback ? 'EditerLigneCommandeChangementStatutBilletterieRetourPopup' : 'EditerLigneCommandeChangementStatutGestionModel';

        const xml = `
            <ligneCommande i:type="d4p1:${type}"
                xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                ${getXmlLine(line, 'CodeStatut')}
                ${getXmlLine(line, 'IdArticle')}
                ${getXmlLine(line, 'IdBenef')}
                ${getXmlLine(line, 'IdCommande')}
                ${getXmlLine(line, 'IdLigneCommande')}
                ${getXmlLine(line, 'Quantite')}
                ${generateSubventionsList()}
            </ligneCommande>
        `;

        function generateSubventionsList(): string {
            const feedBackModel = (line as EditerLigneCommandeChangementStatutBilletterieRetourPopupInput);
            const subventionsList = feedBackModel?.ListeSubventionsAccordeesObs?.SubventionAccordeeModelDTO || [];
            if (!arrayNotEmpty(subventionsList)) {
                return '';
            }

            return `
                <d4p1:ListeSubventionsAccordeesObs>
                    ${subventionsList
                .filter(s => !!s.IsSubventionChoisie)
                .map(subvention => `
                        <d4p1:SubventionAccordeeModelDTO>
                            <d4p1:Status>INSERTED</d4p1:Status>
                            ${getXmlLine(subvention, 'IdEnveloppeSpecifique')}
                            ${getXmlLine(subvention, 'IsSubventionChoisie')}
                            ${getXmlLine(subvention, 'MontantAccepte')}
                        </d4p1:SubventionAccordeeModelDTO>
                    `)
                .join('')}
                </d4p1:ListeSubventionsAccordeesObs>
            `;
        }

        return xml;
    };

export const EditerLigneCommandeChangementStatutLocationGestionModel = ({line, isEngineFeedback}: {
    line: ActivityNewSaleOrderLineStatus,
    isEngineFeedback?: boolean
}) => {
    const type = isEngineFeedback ? 'EditerLigneCommandeChangementStatutLocationGestionRetourPopup' : 'EditerLigneCommandeChangementStatutLocationGestionModel';

    const xml = `
            <ligneCommande i:type="dto:${type}"
                xmlns:dto="http://schemas.datacontract.org/2004/07/V2DTO"
                xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    ${getXmlLine(line, 'CodeStatut', {namespace: 'dto'})}
                    ${getXmlLine(line, 'IdArticle', {namespace: 'dto'})}
                    ${getXmlLine(line, 'IdBenef', {namespace: 'dto'})}
                    ${getXmlLine(line, 'IdCommande', {namespace: 'dto'})}
                    ${getXmlLine(line, 'IdLigneCommande', {namespace: 'dto'})}
                    ${getXmlLine(line, 'Quantite', {namespace: 'dto'})}
                    ${generateSubventionsList()}
            </ligneCommande>
        `;

    function generateSubventionsList(): string {
        const feedBackModel = (line as EditerLigneCommandeChangementStatutLocationGestionRetourPopupInput);
        const subventionsList = feedBackModel?.ListeSubventionsAccordeesObs?.SubventionAccordeeModelDTO || [];

        if (arrayEmpty(subventionsList)) {
            return '';
        }

        return `
                <dto:ListeSubventionsAccordeesObs>
                    ${subventionsList
            .filter(s => !!s.IsSubventionChoisie)
            .map(subvention => `
                        <dto:SubventionAccordeeModelDTO>
                            <dto:Status>INSERTED</dto:Status>
                            ${getXmlLine(subvention, 'IdEnveloppeSpecifique', {namespace: 'dto'})}
                            ${getXmlLine(subvention, 'IsSubventionChoisie', {namespace: 'dto'})}
                            ${getXmlLine(subvention, 'MontantAccepte', {namespace: 'dto'})}
                            ${getXmlLine(subvention, 'MontantMaximum', {namespace: 'dto'})}
                        </dto:SubventionAccordeeModelDTO>
                    `)
            .join('')}
                </dto:ListeSubventionsAccordeesObs>
            `;
    }

    return xml;
};

const isGeneric = (line: SelectedSubventionOrderLine) => !!line.ReferenceArticle;

const GetEditerLigneXml = (line: SelectedSubventionOrderLine) => {
    return [
        'CodeModeLivraison',
        'IdArticle',
        'IdBenef',
        'IdCommande',
        'IdLigneCommande',
        'LibelleLignecommande',
        'Quantite',
        'RemarquePrivee',
        'RemarquePublique',
        'DateReappro',
        'QuantiteALivrer'
    ].map(prop => getXmlLine(line, prop)).join('');
};
